import * as tslib_1 from "tslib";
import { getItem, checkIfResponseSuccess, getBaseItemResponseShape } from 'owa-mail-store';
import { action } from 'satcheljs/lib/legacy';
var updateItemRecipients = function updateItemRecipients(originalItem, responseItem) {
    var existingItem = originalItem;
    var newItem = responseItem;
    existingItem.ToRecipients = newItem.ToRecipients;
    existingItem.CcRecipients = newItem.CcRecipients;
    existingItem.BccRecipients = newItem.BccRecipients;
};
updateItemRecipients = action('updateItemRecipients')(updateItemRecipients);
export default function loadAllRecipientsForItem(item) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var itemShape, response, responseItem;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    itemShape = getBaseItemResponseShape();
                    itemShape.MaximumRecipientsToReturn = 0;
                    return [4 /*yield*/, getItem([item.ItemId.Id], itemShape, 'ItemPart')];
                case 1:
                    response = _a.sent();
                    if (checkIfResponseSuccess(response[0])) {
                        responseItem = response[0];
                        updateItemRecipients(item, responseItem.Items[0]);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loadAllRecipientsForItem.js.map